<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :class="[`${prefix}-icon`, `${prefix}-icon-appChat`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_f6b0e21bc4__a"><rect width="20" height="20" rx="0"/></clipPath></defs><g clip-path="url(#svg_f6b0e21bc4__a)"><path d="M14.3696,12.4416L4.96389,12.4416C4.62448,12.4416,4.28967,12.5301,3.98575,12.7003L2.73836,13.398C2.168594,13.7167,1.5,13.25,1.5,12.5337L1.5,3.33615C1.499999761614,2.322073,2.229953,1.5,3.1304,1.5L14.3696,1.5C15.27,1.5,16,2.322073,16,3.33615L16,10.60543C16,11.6195,15.27,12.4416,14.3696,12.4416Z" :fill="useCurrentColor ? 'currentColor' : '#00CA47'"/><path d="M7.46164,17.11805L15.89447,17.11805C16.198700000000002,17.118029999999997,16.4989,17.191760000000002,16.7714,17.33345L17.8896,17.91496C18.400399999999998,18.1806,18.9999,17.79178,19,17.19481L19,9.53093C19.000500000000002,8.685585,18.346,8,17.5384,8L7.46164,8C6.654016,8,5.999456736,8.685587,6,9.53093L6,15.58789C5.999864903,16.43293,6.654303,17.11805,7.46164,17.11805Z" :fill="useCurrentColor ? 'currentColor' : '#55E48B'"/><path d="M7.51244,8C6.676744,8,5.999437857,8.558656,6,9.247489999999999L6,12.5L14.30493,12.5C15.24115,12.5,16,11.87436,16,11.10266L16,8L7.51244,8Z" :fill="useCurrentColor ? 'currentColor' : '#00BB24'"/></g></svg>
</template>
<script>

export default {
  name: 'IconAppChat',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
